import React from 'react';
import cx from 'classnames';

import styles from './cartContainer.module.less';

/**
 * Provides the named container for media queries sizing the cart.
 */
export const CartContainer: React.FC<{ className?: string }> = ({ children, className }) => {
  return <div className={cx(styles.cartContainer, className)}>{children}</div>;
};

/**
 * Provides spacing around the cart.
 */
export const CartWrapper: React.FC<{ className?: string }> = ({ children, className }) => {
  return <div className={cx(styles.cartWrapper, className)}>{children}</div>;
};
